/**
 * Styled Components - Created by gustavomedina on 23/04/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  height: 300px;
  background-color: #fff;
  margin: 0 23px;
  padding-top: 18px;
`

export const EmptyContainer = styled.div`
  display: flex;
  height: 25vh;
  justify-content: center;
  align-items: center;
`

export const EmptyMessage = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
`

export const Arrow = styled.img`
  height: 60px !important;
  width: 50px !important;
  border-radius: 5px;
  padding: 19px !important;
  text-align: center !important;
  z-index: 1 !important;
  border: 0.2px solid rgba(220,220,220,0.34) !important;
  filter: brightness(10.5);
  background-color: #0000003b !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.07) !important;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterRelated/styledComponents.tsx